var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{class:{ 'exit-campaign-tag': _vm.extendedHeight },attrs:{"options":_vm.options,"label":_vm.label,"trackBy":_vm.trackBy,"selectLabel":"","deselectLabel":"","selectedLabel":"","multiple":true,"taggable":false,"searchable":true},model:{value:(_vm.checkValue),callback:function ($$v) {_vm.checkValue=$$v},expression:"checkValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }